import React, { useState } from "react";
import "../../assests/css/SearchDriver.css";
// import SearchDrivers from './SearchDrivers';

const drivers = [
  {
    id: 1,
    name: "Ahmed Hassan",
    location: "Doha",
    experience: "8 Years",
    type: "Professional Driver",
    status: "Available",
  },
  {
    id: 2,
    name: "Mohammed Ali",
    location: "Al Wakrah",
    experience: "6 Years",
    type: "Family Driver",
    status: "Available",
  },
  {
    id: 3,
    name: "Abdul Rahman",
    location: "Al Rayyan",
    experience: "10 Years",
    type: "Heavy Vehicle Driver",
    status: "Available",
  },
  {
    id: 4,
    name: "Sameer Khan",
    location: "Doha",
    experience: "5 Years",
    type: "Delivery Driver",
    status: "Available",
  },
  {
    id: 5,
    name: "Rashid Ahmed",
    location: "Lusail",
    experience: "7 Years",
    type: "Professional Driver",
    status: "Available",
  },
  {
    id: 6,
    name: "Ibrahim Saleh",
    location: "Al Khor",
    experience: "9 Years",
    type: "Bus Driver",
    status: "Available",
  },
];

function SearchDrivers() {

  const [driverName, setDriverName] = useState("");
  const [location, setLocation] = useState("");
  const [driverType, setDriverType] = useState("");

  const [searchResults, setSearchResults] = useState(drivers);


  const handleSearch = () => {

    const results = drivers.filter((driver) => {

      const nameMatch =
        driver.name
          .toLowerCase()
          .includes(driverName.toLowerCase());

      const locationMatch =
        location === "" ||
        driver.location === location;

      const typeMatch =
        driverType === "" ||
        driver.type === driverType;

      return nameMatch && locationMatch && typeMatch;

    });

    setSearchResults(results);
  };


  const handleReset = () => {

    setDriverName("");
    setLocation("");
    setDriverType("");

    setSearchResults(drivers);
  };


  return (

    <section className="search-drivers">

      {/* ================= HEADER ================= */}

      <div className="drivers-header">

        <h1>
          Search for Drivers
        </h1>

        <p>
          Find professional drivers based on name,
          location and driver type.
        </p>

      </div>


      {/* ================= SEARCH BOX ================= */}

      <div className="driver-search-box">

        {/* DRIVER NAME */}

        <div className="driver-field">

          <label>
            Driver Name
          </label>

          <input
            type="text"
            placeholder="Enter driver name"
            value={driverName}
            onChange={(e) =>
              setDriverName(e.target.value)
            }
          />

        </div>


        {/* LOCATION */}

        <div className="driver-field">

          <label>
            Location
          </label>

          <select
            value={location}
            onChange={(e) =>
              setLocation(e.target.value)
            }
          >

            <option value="">
              All Locations
            </option>

            <option value="Doha">
              Doha
            </option>

            <option value="Al Wakrah">
              Al Wakrah
            </option>

            <option value="Al Rayyan">
              Al Rayyan
            </option>

            <option value="Lusail">
              Lusail
            </option>

            <option value="Al Khor">
              Al Khor
            </option>

          </select>

        </div>


        {/* DRIVER TYPE */}

        <div className="driver-field">

          <label>
            Driver Type
          </label>

          <select
            value={driverType}
            onChange={(e) =>
              setDriverType(e.target.value)
            }
          >

            <option value="">
              All Driver Types
            </option>

            <option value="Professional Driver">
              Professional Driver
            </option>

            <option value="Family Driver">
              Family Driver
            </option>

            <option value="Heavy Vehicle Driver">
              Heavy Vehicle Driver
            </option>

            <option value="Delivery Driver">
              Delivery Driver
            </option>

            <option value="Bus Driver">
              Bus Driver
            </option>

          </select>

        </div>


        {/* SEARCH BUTTON */}

        <button
          className="driver-search-button"
          onClick={handleSearch}
        >
          🔍 Search
        </button>


        {/* RESET */}

        <button
          className="driver-reset-button"
          onClick={handleReset}
        >
          Reset
        </button>

      </div>


      {/* ================= RESULTS ================= */}

      <div className="driver-results-header">

        <h2>
          Available Drivers
        </h2>

        <span>
          {searchResults.length} Drivers Found
        </span>

      </div>


      {/* ================= DRIVER CARDS ================= */}

      <div className="drivers-grid">

        {searchResults.length > 0 ? (

          searchResults.map((driver) => (

            <div
              className="driver-card"
              key={driver.id}
            >

              {/* DRIVER ICON */}

              <div className="driver-avatar">
                👤
              </div>


              {/* DRIVER DETAILS */}

              <div className="driver-details">

                <h3>
                  {driver.name}
                </h3>

                <p>
                  📍 {driver.location}
                </p>

                <p>
                  💼 {driver.type}
                </p>

                <p>
                  ⭐ {driver.experience} Experience
                </p>

                <span className="driver-status">
                  ● {driver.status}
                </span>

              </div>


              {/* VIEW BUTTON */}

              <button className="view-driver-button">
                View Profile
              </button>

            </div>

          ))

        ) : (

          <div className="no-drivers">

            <div>
              🔍
            </div>

            <h3>
              No Drivers Found
            </h3>

            <p>
              Try changing your search criteria.
            </p>

          </div>

        )}

      </div>

    </section>

  );
}

export default SearchDrivers;